'use strict';

var _toConsumableArray = require("/home/cjh/tmp/edp/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/cjh/tmp/edp/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var createScatter = require('regl-scatter2d');

var pick = require('pick-by-alias');

var getBounds = require('array-bounds');

var raf = require('raf');

var arrRange = require('array-range');

var rect = require('parse-rect');

var flatten = require('flatten-vertex-data');

module.exports = SPLOM; // @constructor

function SPLOM(regl, options) {
  if (!(this instanceof SPLOM)) return new SPLOM(regl, options); // render passes

  this.traces = []; // passes for scatter, combined across traces

  this.passes = {};
  this.regl = regl; // main scatter drawing instance

  this.scatter = createScatter(regl);
  this.canvas = this.scatter.canvas;
} // update & draw passes once per frame


SPLOM.prototype.render = function () {
  var _this = this;

  if (arguments.length) {
    this.update.apply(this, arguments);
  }

  if (this.regl.attributes.preserveDrawingBuffer) return this.draw(); // make sure draw is not called more often than once a frame

  if (this.dirty) {
    if (this.planned == null) {
      this.planned = raf(function () {
        _this.draw();

        _this.dirty = true;
        _this.planned = null;
      });
    }
  } else {
    this.draw();
    this.dirty = true;
    raf(function () {
      _this.dirty = false;
    });
  }

  return this;
}; // update passes


SPLOM.prototype.update = function () {
  var _this$scatter;

  if (!arguments.length) return;

  for (var i = 0; i < arguments.length; i++) {
    this.updateItem(i, i < 0 || arguments.length <= i ? undefined : arguments[i]);
  } // remove nulled passes


  this.traces = this.traces.filter(Boolean); // FIXME: update passes independently

  var passes = [];
  var offset = 0;

  for (var _i = 0; _i < this.traces.length; _i++) {
    var trace = this.traces[_i];
    var tracePasses = this.traces[_i].passes;

    for (var j = 0; j < tracePasses.length; j++) {
      passes.push(this.passes[tracePasses[j]]);
    } // save offset of passes


    trace.passOffset = offset;
    offset += trace.passes.length;
  }

  (_this$scatter = this.scatter).update.apply(_this$scatter, passes);

  return this;
}; // update trace by index, not supposed to be called directly


SPLOM.prototype.updateItem = function (i, options) {
  var regl = this.regl; // remove pass if null

  if (options === null) {
    this.traces[i] = null;
    return this;
  }

  if (!options) return this;
  var o = pick(options, {
    data: 'data items columns rows values dimensions samples x',
    snap: 'snap cluster',
    size: 'sizes size radius',
    color: 'colors color fill fill-color fillColor',
    opacity: 'opacity alpha transparency opaque',
    borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
    borderColor: 'borderColors borderColor bordercolor stroke stroke-color strokeColor',
    marker: 'markers marker shape',
    range: 'range ranges databox dataBox',
    viewport: 'viewport viewBox viewbox',
    domain: 'domain domains area areas',
    padding: 'pad padding paddings pads margin margins',
    transpose: 'transpose transposed',
    diagonal: 'diagonal diag showDiagonal',
    upper: 'upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf',
    lower: 'lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower'
  }); // we provide regl buffer per-trace, since trace data can be changed

  var trace = this.traces[i] || (this.traces[i] = {
    id: i,
    buffer: regl.buffer({
      usage: 'dynamic',
      type: 'float',
      data: new Uint8Array()
    }),
    color: 'black',
    marker: null,
    size: 12,
    borderColor: 'transparent',
    borderSize: 1,
    viewport: rect([regl._gl.drawingBufferWidth, regl._gl.drawingBufferHeight]),
    padding: [0, 0, 0, 0],
    opacity: 1,
    diagonal: true,
    upper: true,
    lower: true
  }); // save styles

  if (o.color != null) {
    trace.color = o.color;
  }

  if (o.size != null) {
    trace.size = o.size;
  }

  if (o.marker != null) {
    trace.marker = o.marker;
  }

  if (o.borderColor != null) {
    trace.borderColor = o.borderColor;
  }

  if (o.borderSize != null) {
    trace.borderSize = o.borderSize;
  }

  if (o.opacity != null) {
    trace.opacity = o.opacity;
  }

  if (o.viewport) {
    trace.viewport = rect(o.viewport);
  }

  if (o.diagonal != null) trace.diagonal = o.diagonal;
  if (o.upper != null) trace.upper = o.upper;
  if (o.lower != null) trace.lower = o.lower; // put flattened data into buffer

  if (o.data) {
    trace.buffer(flatten(o.data));
    trace.columns = o.data.length;
    trace.count = o.data[0].length; // detect bounds per-column

    trace.bounds = [];

    for (var _i2 = 0; _i2 < trace.columns; _i2++) {
      trace.bounds[_i2] = getBounds(o.data[_i2], 1);
    }
  } // add proper range updating markers


  var multirange;

  if (o.range) {
    trace.range = o.range;
    multirange = trace.range && typeof trace.range[0] !== 'number';
  }

  if (o.domain) {
    trace.domain = o.domain;
  }

  var multipadding = false;

  if (o.padding != null) {
    // multiple paddings
    if (Array.isArray(o.padding) && o.padding.length === trace.columns && typeof o.padding[o.padding.length - 1] === 'number') {
      trace.padding = o.padding.map(getPad);
      multipadding = true;
    } // single padding
    else {
        trace.padding = getPad(o.padding);
      }
  } // create passes


  var m = trace.columns;
  var n = trace.count;
  var w = trace.viewport.width;
  var h = trace.viewport.height;
  var left = trace.viewport.x;
  var top = trace.viewport.y;
  var iw = w / m;
  var ih = h / m;
  trace.passes = [];

  for (var _i3 = 0; _i3 < m; _i3++) {
    for (var j = 0; j < m; j++) {
      if (!trace.diagonal && j === _i3) continue;
      if (!trace.upper && _i3 > j) continue;
      if (!trace.lower && _i3 < j) continue;
      var key = passId(trace.id, _i3, j);
      var pass = this.passes[key] || (this.passes[key] = {});

      if (o.data) {
        if (o.transpose) {
          pass.positions = {
            x: {
              buffer: trace.buffer,
              offset: j,
              count: n,
              stride: m
            },
            y: {
              buffer: trace.buffer,
              offset: _i3,
              count: n,
              stride: m
            }
          };
        } else {
          pass.positions = {
            x: {
              buffer: trace.buffer,
              offset: j * n,
              count: n
            },
            y: {
              buffer: trace.buffer,
              offset: _i3 * n,
              count: n
            }
          };
        }

        pass.bounds = getBox(trace.bounds, _i3, j);
      }

      if (o.domain || o.viewport || o.data) {
        var pad = multipadding ? getBox(trace.padding, _i3, j) : trace.padding;

        if (trace.domain) {
          var _getBox = getBox(trace.domain, _i3, j),
              _getBox2 = _slicedToArray(_getBox, 4),
              lox = _getBox2[0],
              loy = _getBox2[1],
              hix = _getBox2[2],
              hiy = _getBox2[3];

          pass.viewport = [left + lox * w + pad[0], top + loy * h + pad[1], left + hix * w - pad[2], top + hiy * h - pad[3]];
        } // consider auto-domain equipartial
        else {
            pass.viewport = [left + j * iw + iw * pad[0], top + _i3 * ih + ih * pad[1], left + (j + 1) * iw - iw * pad[2], top + (_i3 + 1) * ih - ih * pad[3]];
          }
      }

      if (o.color) pass.color = trace.color;
      if (o.size) pass.size = trace.size;
      if (o.marker) pass.marker = trace.marker;
      if (o.borderSize) pass.borderSize = trace.borderSize;
      if (o.borderColor) pass.borderColor = trace.borderColor;
      if (o.opacity) pass.opacity = trace.opacity;

      if (o.range) {
        pass.range = multirange ? getBox(trace.range, _i3, j) : trace.range || pass.bounds;
      }

      trace.passes.push(key);
    }
  }

  return this;
}; // draw all or passed passes


SPLOM.prototype.draw = function () {
  var _this2 = this;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (!args.length) {
    this.scatter.draw();
  } else {
    (function () {
      var _this2$scatter;

      var idx = [];

      for (var i = 0; i < args.length; i++) {
        // draw(0, 2, 5) - draw traces
        if (typeof args[i] === 'number') {
          var _this2$traces$args$i = _this2.traces[args[i]],
              passes = _this2$traces$args$i.passes,
              passOffset = _this2$traces$args$i.passOffset;
          idx.push.apply(idx, _toConsumableArray(arrRange(passOffset, passOffset + passes.length)));
        } // draw([0, 1, 2 ...], [3, 4, 5]) - draw points
        else if (args[i].length) {
            (function () {
              var els = args[i];
              var _this2$traces$i = _this2.traces[i],
                  passes = _this2$traces$i.passes,
                  passOffset = _this2$traces$i.passOffset;
              passes = passes.map(function (passId, i) {
                idx[passOffset + i] = els;
              });
            })();
          }
      }

      (_this2$scatter = _this2.scatter).draw.apply(_this2$scatter, idx);
    })();
  }

  return this;
}; // dispose resources


SPLOM.prototype.destroy = function () {
  this.traces.forEach(function (trace) {
    if (trace.buffer && trace.buffer.destroy) trace.buffer.destroy();
  });
  this.traces = null;
  this.passes = null;
  this.scatter.destroy();
  return this;
}; // return pass corresponding to trace i- j- square


function passId(trace, i, j) {
  var id = trace.id != null ? trace.id : trace;
  var n = i;
  var m = j;
  var key = id << 16 | (n & 0xff) << 8 | m & 0xff;
  return key;
} // return bounding box corresponding to a pass


function getBox(items, i, j) {
  var ilox, iloy, ihix, ihiy, jlox, jloy, jhix, jhiy;
  var iitem = items[i],
      jitem = items[j];

  if (iitem.length > 2) {
    ilox = iitem[0];
    ihix = iitem[2];
    iloy = iitem[1];
    ihiy = iitem[3];
  } else if (iitem.length) {
    ilox = iloy = iitem[0];
    ihix = ihiy = iitem[1];
  } else {
    ilox = iitem.x;
    iloy = iitem.y;
    ihix = iitem.x + iitem.width;
    ihiy = iitem.y + iitem.height;
  }

  if (jitem.length > 2) {
    jlox = jitem[0];
    jhix = jitem[2];
    jloy = jitem[1];
    jhiy = jitem[3];
  } else if (jitem.length) {
    jlox = jloy = jitem[0];
    jhix = jhiy = jitem[1];
  } else {
    jlox = jitem.x;
    jloy = jitem.y;
    jhix = jitem.x + jitem.width;
    jhiy = jitem.y + jitem.height;
  }

  return [jlox, iloy, jhix, ihiy];
}

function getPad(arg) {
  if (typeof arg === 'number') return [arg, arg, arg, arg];else if (arg.length === 2) return [arg[0], arg[1], arg[0], arg[1]];else {
    var box = rect(arg);
    return [box.x, box.y, box.x + box.width, box.y + box.height];
  }
}